export default [
  {
    path: '/parametrizacao-template-pacote',
    component: {
      name: 'template-pacote-root',
      template: '<router-view />',
      meta: {
        resource: 'template',
        action: 'read',
        requiredAuth: true,
        breadcrumb: [
          { text: '', to: { path: '/' } },
        ],
      },
    },
    children: [
      {
        path: 'visualizar',
        name: 'template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/template/ParametrizacaoTemplatePacote.vue'),
        meta: {
          resource: 'template',
          action: 'read',
          pageTitle: 'Grupos de pacotes',
          breadcrumb: [
            {
              text: 'Grupos de pacotes',
              to: { name: 'template-pacote' },
              active: true,
            },
          ],
        },
      },
      {
        path: 'grupos/novo',
        name: 'novo-grupo-template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/components/CadastroGrupoTemplatePacote.vue'),
        meta: {
          resource: 'template',
          action: 'create',
          requiredAuth: true,
          navActiveLink: 'template-pacote',
          pageTitle: 'Grupo de pacotes',
          breadcrumb: [
            { text: 'Grupos de pacotes', to: { name: 'template-pacote' } },
            { text: 'Novo', active: true },
          ],
        },
      },
      {
        path: 'grupos/:grupoId',
        name: 'editar-grupo-template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/components/CadastroGrupoTemplatePacote.vue'),
        meta: {
          resource: 'template',
          action: 'update',
          requiredAuth: true,
          navActiveLink: 'template-pacote',
          pageTitle: 'Grupo de pacotes',
          breadcrumb: [
            { text: 'Grupos de pacotes', to: { name: 'template-pacote' } },
            { text: 'Editar', active: true },
          ],
        },
      },
      {
        path: 'grupos/:grupoId/editar/:id',
        name: 'editar-template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/components/cadastro-template/EditorCadastroPacote.vue'),
        meta: {
          resource: 'template',
          action: 'update',
          requiredAuth: true,
          navActiveLink: 'template-pacote',
          pageTitle: 'Template de Pacotes',
          breadcrumb: [
            {
              text: 'Grupos de pacotes',
              to: { name: 'template-pacote' },
            },
            {
              text: 'editar',
              to: { name: 'editar-template-pacote' },
              active: true,
            },
          ],
        },
      },
    ],
  },
]
